import React, { useMemo, useState } from 'react';
import { calcularResumoPorTipo, calcularResumoPorDefensor, calcularResumoPorDefensoria } from '../movimentacao.service';
import { RMovimentoDto } from '@/api.types';

interface ResumoTipoQuantidadeProps {
  dados: RMovimentoDto[];
  agrupamento: 'tipo' | 'defensor' | 'defensoria'
  htmlTableId?: string
}

const ResumoTipoQuantidade: React.FC<ResumoTipoQuantidadeProps> = ({ dados, agrupamento, htmlTableId = 'resumoTipoQuantidade' }) => {

  const [orderValor, setOrdenarPorValor] = useState(false);
  const [dividirTabela, setDividirTabela] = useState(false);

  const resumo = useMemo(() => {

    switch (agrupamento) {
      case 'tipo':
        return calcularResumoPorTipo(dados);
      case 'defensor':
        return calcularResumoPorDefensor(dados)
      case 'defensoria':
        return calcularResumoPorDefensoria(dados)
    }
  }, [dados]);

  if (!resumo)
    return <></>;

  const metade = dividirTabela ? Math.ceil(resumo.length / 2) : resumo.length;
  const primeiraColuna = dividirTabela ? resumo.slice(0, metade) : resumo;
  const segundaColuna = resumo.slice(metade);

  let totalGeral = 0;

  return (
    <>
      <div className='col-md-6 d-print-none row'>
        <div className="form-check form-switch col-auto">
          <input className="form-check-input" type="checkbox" id="orderValor" checked={orderValor}
            onChange={(e) => {
              setOrdenarPorValor(e.target.checked);
            }}
          />
          <label className="form-check-label" htmlFor="orderValor">
            Ordenar por valor
          </label>
        </div>

        <div className="form-check form-switch col-auto">
          <input
            className="form-check-input"
            type="checkbox"
            id="dividirTabela"
            checked={dividirTabela}
            onChange={(e) => {
              setDividirTabela(e.target.checked);
            }}
          />
          <label className="form-check-label" htmlFor="dividirTabela">
            Dividir ao meio
          </label>
        </div>
      </div>

      <div className='row'>
        {[primeiraColuna, segundaColuna]
          .filter((a) => a.length > 0)
          .map((coluna, colunaIndex) => (
            <div key={colunaIndex} className={`${dividirTabela ? 'col-md-6' : 'col-md-12'}`}>
              <table className="table table-bordered table-sm table-striped body-tabela-resumo" id={htmlTableId}>
                <thead>
                  <tr>
                    <th>
                      {agrupamento.toUpperCase()}
                    </th>
                    <th className='text-center'>
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {coluna
                    .slice()
                    .sort((a, b) =>
                      orderValor
                        ? b.quantidade - a.quantidade
                        : a.tipo && b.tipo
                          ? a.tipo?.localeCompare(b.tipo)
                          : 0,
                    )
                    .map((itemResumo, index) => {
                      totalGeral += itemResumo.quantidade
                      return (
                        <tr key={index}>
                          <td>{itemResumo.tipo}</td>
                          <td className="text-end">{itemResumo.quantidade}</td>
                        </tr>
                      )
                    })}
                  {!dividirTabela &&
                    <tr className="fw-bold border-top">
                      <td className='text-end'>Total Geral</td>
                      <td className="text-end">{totalGeral}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          ))}
      </div >
    </>
  );
};

export default ResumoTipoQuantidade;
